// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeTwoToneSvg from "@ant-design/icons-svg/es/asn/EyeTwoTone";
import AntdIcon from '../components/AntdIcon';

var EyeTwoTone = function EyeTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeTwoToneSvg
  }));
};

EyeTwoTone.displayName = 'EyeTwoTone';
export default React.forwardRef(EyeTwoTone);